import { ComponentType } from "react";

export interface BroadcastFilter {
  bfc?: string;
  city?: string[];
  zipcode?: string[];
  bussType?: string[];
  subBussType?: string[];
  classification?: string[];
  certification?: string[];
  businessChannels?: string[];
  emergOrEst?: string;
  lastContact?: string;
}

export interface ContentData {
  subject: string;
  htmlContent: string;
  eventId?: string;
}

export interface ContentStepProps {
  contentData: ContentData;
  setContentData: (data: ContentData) => void;
  onNext: () => void;
}

export interface BroadcastTypeConfig {
  id: string;
  label: string;
  description: string;
  iconName: string; // MUI icon name string — resolved in TypeSelector
}

export const BROADCAST_TYPES: BroadcastTypeConfig[] = [
  {
    id: "event_invitation",
    label: "Event Invitation",
    description:
      "Send an event invitation to firms. Choose an upcoming event and your recipients will receive a branded invite with event details.",
    iconName: "Event",
  },
  {
    id: "custom_email",
    label: "Custom Email",
    description:
      "Compose a custom broadcast email from scratch or from a saved template.",
    iconName: "Email",
  },
];
